import { Component, OnInit } from '@angular/core';
import { SeoService } from '../../../services/seo.service';

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.scss']
})
export class DocumentationComponent implements OnInit {

  constructor(private seoService: SeoService) { }

  ngOnInit(): void {
    this.seoService.setSEOTags(
      'Documentation',
      'Comprehensive documentation for Insightful IT Services Cloud and Managed IT Solutions. Technical guides, API references, and best practices for India-based enterprises.',
      'Cloud Documentation, IT Services Documentation, Technical Guides, API Reference, Cloud Infrastructure Documentation, Managed IT Documentation'
    );
  }

}